
import {Component, Vue, Prop} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import SvgIcon from "@jamescoyle/vue-icon";

@Component({
  components: {
    SvgIcon,
  },
})
export default class SetCredentials extends Vue {
  @Prop({default : null})
  private currentUserId: number;
  @Prop({default : false})
  private showDialog: boolean;
  @Prop({default : false})
  private hasUserEmail: boolean;
  private form: any = {
      email: "",
      password: "",
  };
  private rules: any = formRules;
  private valid: boolean = true;

  get passwordRulesSet(): any[] {
    return [
      this.rules.required,
      this.rules.length,
      this.rules.uppercase,
      this.rules.lowercase,
      this.rules.number,
      this.rules.special,
    ];
  }

  private setCredentials() {
      this.$store.dispatch("users/setCredentials", {
          email: this.form.email,
          password: this.form.password,
          userId: this.currentUserId ,
      }).then((data) => {
          this.$emit("close-modal");
          this.$store.commit("alerts/displaySuccess", {
              msg: this.$t("alerts.success.emailSet"),
          });
          this.$store.dispatch("banner/setHasUserPassword", true);
      }).catch((err) => {
          this.$store.commit("alerts/displayError", {
              msg: this.$t(`alerts.error.${err.response.data.message}`),
          });
      });
  }
}
